import React, { useState, useContext } from "react"
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import Alert from "react-bootstrap/Alert"
import { serverAPI } from "../../services/api/apiParams"
import { userContext } from "../../App"
import DatePicker from "../mealPlanner/DatePicker"

function AddMealPlanner({ show, handleClose, recipe }) {
  const [errorMessage, setErrorMessage] = useState("")
  const [add, setAdd] = useState("Add")
  const { user, setUser } = useContext(userContext)
  const [selectedDate, setSelectedDate] = useState()

  const addToMealPlanner = async (recipe) => {
    if (user.id === undefined) {
      return setErrorMessage("You are not logged in")
    }
    setErrorMessage("")

    let event = {
      date: selectedDate,
      title: recipe.title,
      api_id: recipe.id,
      image: recipe.image,
      user_id: user.id,
    }
    try {
      await serverAPI.post("/api/meal-event", event, {
        headers: { "Content-Type": "application/json" },
      })
      setAdd("Added")
    } catch (error) {
      setErrorMessage(error.response.data.message)
    }
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      onExit={() => {
        //reset onexit
        setErrorMessage("")
        setAdd("Add")
      }}>
      <Modal.Header closeButton>
        <Modal.Title>Add to Meal PLanner</Modal.Title>
      </Modal.Header>
      <div className='imgBox'>
        <img src={recipe.image} alt='recipe' className='img-fluid' />
      </div>
      <Modal.Header>
        {errorMessage.length > 0 ? (
          <Alert className='mt-2 alert text-center popup-alert w-100'>
            {errorMessage ?? errorMessage}
          </Alert>
        ) : (
          ""
        )}
      </Modal.Header>
      <Modal.Header>{recipe.title}</Modal.Header>
      <Modal.Body>
        <h4>Select a date</h4>
        <div className='w-50'>
          <DatePicker setSelectedDate={setSelectedDate} setAdd={setAdd} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className='myBtn'
          onClick={() => {
            addToMealPlanner(recipe)
          }}>
          {add}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AddMealPlanner
